import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'

const config = new MockAdapter(axios)

export default config
